import React from 'react';

const LandingPage = React.lazy(() => import('pages/LandingPage/LandingPage'));
const LandingPageAdd = React.lazy(() => import('pages/LandingPage/LandingPageAdd'));

const landingPageRoute = [
    {
        path: '/landing-page',
        exact: true,
        name: 'Danh sách landing page',
        function: 'CMS_LANDINGPAGE_VIEW',
        component: LandingPage,
    },
    {
        path: '/landing-page/add',
        exact: true,
        name: 'Thêm mới landing page',
        function: 'CMS_LANDINGPAGE_ADD',
        component: LandingPageAdd,
    },
    {
        path: '/landing-page/edit/:landing_page_id',
        exact: true,
        name: 'Chỉnh sửa landing page',
        function: 'CMS_LANDINGPAGE_EDIT',
        component: LandingPageAdd,
    },
    {
        path: '/landing-page/detail/:landing_page_id',
        exact: true,
        name: 'Chi tiết landing page',
        function: 'CMS_LANDINGPAGE_VIEW',
        component: LandingPageAdd,
    },
];

export default landingPageRoute;
